import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { AbstractConstantCustomFieldAddComponent, mapStateToProps } from './abstract'
import { Button, Input, TextArea, Checkbox } from '~/components/form'
import DatePicker from 'react-datepicker'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import * as route from '~/helper/constant/route'
import { withTranslation } from 'react-i18next'
import { Loading } from '~/components/loader'
import * as SVG from '~/assets/svg'
import Select from 'react-select'
import { ColorPicker } from '~/components/form/color-picker'

class ConstantCustomFieldAddComponent extends AbstractConstantCustomFieldAddComponent{
    constructor(props){
        super(props)
        this.state = {
            ...this.state,
        }
    }
    render(){
        const {t} = this.props
        return(
            <div className="main-page">
                <Loading status={this.state.loading} text="Saving" />
                <Sidebar id="constant" isAccount={true} />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>{t('sidebar:account')} &nbsp; &gt; </a>
                            </li>
                            <li>
                            <a href={route.admin.accounting.constant.menu}>{t('constant:constant')} &nbsp; &gt; &nbsp;</a>
                            </li>
                            <li><a href={route.admin.accounting.constant.customfield.view}>{t("constant:customfield")} &nbsp; &gt; &nbsp; </a></li>
                            <li>{t('common:addBtn')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('constant:createnewcustomfield')} :</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-form">
                        <form>
                            <div className="row clearfix">
                            <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('constant:customfieldname')} </label>
                                    <Input name="title" placeholder={t('constant:customfieldname')} type="text" value="" />
                                   
                                </div>
                                <div className="col-md-6 float-left form-group">
                                    <label className="form-title text-left">{t('attendance:type')} </label>
                                    <Select name="class" options={this.state.type_list} placeholder="" searchable={true} />
                                </div>
                                <div className="col-md-6 float-left form-group">
                                    <label className="form-title text-left">{t('course:module')} </label>
                                    <Select name="class" options={this.state.module_list} placeholder="" searchable={true} />
                                </div>
                               

                            </div>
                        </form>
                    </div>
                    <div className="form-button text-left">
                        <Button onClick={this.onSave} type="submit" text={t('common:savebtn')} main={true} />
                    </div>
                </div>
            </div>
        )

    }

}

const ConstantCustomFieldAdd = withTranslation()(connect(mapStateToProps)(ConstantCustomFieldAddComponent))
export {ConstantCustomFieldAdd}